import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "casofin",
  interest_rate: 30,
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  cotizador: {
    type: "simple",
    tax_system_codes: {
      pm: "CFD03",
      pfae: "CFD04",
    },
    enable_guarantee: false,
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_BeRV6uYmO",
      userPoolClientId: "208j2kkvh8r32d2a9qq926t33f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
